export enum ModalSizes {
  md,
  sm,
  lg,
  xs,
}
export enum ModalDisplay {
  show,
  hide,
}
